import { Injectable } from '@angular/core';
import { PaymentApiClient } from './payment-.api.client';
import { PaymentInMemoryApiClient } from './payment.api.inmemory.client';
import { IPaymentApiClient } from './i-payment.api.client';
import { ApiClientProvider } from '../../../common';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiClientProvider extends ApiClientProvider<IPaymentApiClient> {
  constructor(
    private client: PaymentApiClient,
    private inMemoryClient: PaymentInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IPaymentApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IPaymentApiClient {
    return this.client;
  }
}
